import React, { useState } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import Spacer from 'Pages/Home/Components/Atoms/Spacer/Spacer';
import Style from './ModalDoubleCheck.module.scss';
import { AiOutlineArrowRight, AiOutlineCloseCircle } from 'react-icons/ai';
import { Button, Col, Row } from 'antd';
import { useHistory } from 'react-router';
import { FaArrowRight } from 'react-icons/fa';

interface IModalDoubleCheckProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

const TERMS = [
  {
    subTitle: 'The Product You Want to Consign is Correct',
    description:
      'I have double check the product image, product name, model number / SKU, size, and other.',
  },
  {
    subTitle: 'The Product’s Condition is Listed Correctly',
    description: 'I have ticked all of the boxes accordingly (if applicable)',
  },
  {
    subTitle: 'Your Item is Packed & Shipped Properly',
    description:
      'I have packed my item properly, wrapped in double boxes to reduce damage during shopping. Any damage that happen during the trip is entirely my responsbility. Kick Avenue will not be responsible for any incident happen during shopping.',
  },
  {
    subTitle: 'You Have Paid for the Shipping Fee',
    description:
      'I have paid for the shipping fee to Kick Avenue’s warehouse, and Kick Avenue is not obligated to pay anything upon acceptance.',
  },
];

const ModalDoubleCheck: React.FC<IModalDoubleCheckProps> = (props) => {
  const { isOpen, onClose, onSubmit } = props;
  const [checked, setChecked] = useState(false);

  return (
    <Modal
      modalClassName={Style['centered']}
      contentClassName={Style['double-check']}
      isOpen={isOpen}
    >
      <ModalBody className={Style['body']}>
        <div className={Style['close']}>
          <AiOutlineCloseCircle className={Style['icon']} onClick={onClose} />
        </div>

        <Row>
          <div className={Style['title']}>Double Check</div>
        </Row>

        {TERMS.map((term) => {
          const { subTitle, description } = term;
          return (
            <Row key={subTitle} className={Style['term']}>
              <Col span={24}>
                <div className={Style['sub-title']}>{subTitle}</div>
              </Col>
              <Col span={24}>
                <div className={Style['description']}>{description}</div>
              </Col>
            </Row>
          );
        })}

        <Spacer height={24} />

        <Row align="middle" justify="space-between">
          <Col span={23}>
            <div className={Style['agreement']}>
              I have read all terms conditions and agree to proceed with the
              transaction.
            </div>
          </Col>
          <Col span={1}>
            <Row align="middle" justify="end">
              <input
                type="checkbox"
                checked={checked}
                onChange={() => {
                  setChecked(!checked);
                }}
              />
            </Row>
          </Col>
        </Row>

        <Button
          className={Style['button']}
          block
          disabled={!checked}
          onClick={onSubmit}
        >
          <Row align="middle" justify="center">
            <Col>Proceed</Col>
            <Col>
              <FaArrowRight
                style={{ marginLeft: 6, marginTop: '-2px' }}
                color={checked ? 'white' : undefined}
              />
            </Col>
          </Row>
        </Button>
      </ModalBody>
    </Modal>
  );
};

export default ModalDoubleCheck;
